import { render, staticRenderFns } from "./CoachsPicturesGridItem.vue?vue&type=template&id=ba939eba&scoped=true"
import script from "./CoachsPicturesGridItem.vue?vue&type=script&lang=js"
export * from "./CoachsPicturesGridItem.vue?vue&type=script&lang=js"
import style0 from "./CoachsPicturesGridItem.vue?vue&type=style&index=0&id=ba939eba&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba939eba",
  null
  
)

export default component.exports